import { createSlice } from "@reduxjs/toolkit";

import { getDestinationsTypesRedux } from "./destinationsTypes.asyncActions";

const initialState = {
    destinations: [],
    status: "idle",
};

export const destinationsTypesSlice = createSlice({
    name: "allDestinationsTypeState",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDestinationsTypesRedux.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getDestinationsTypesRedux.fulfilled, (state, action) => {
                state.status = "idle";
                state.destinations = action.payload.data[0];
            })
            .addCase(getDestinationsTypesRedux.rejected, (state, action) => {
                state.status = "failed";
            });
    },
});

export default destinationsTypesSlice.reducer;
